import { authGateway } from "@/gateways/authGateway";
import { useMutation } from "@tanstack/vue-query";
import { useRouter } from "vue-router";

export function useLogout() {
  const router = useRouter();
  const mutation = useMutation({
    mutationFn: authGateway.logout,
    onSuccess: () => router.push({ name: "login" }),
  });

  return { ...mutation, logout: mutation.mutate };
}
